<template>
  <div class="pt-3">
    <div class="d-flex justify-space-between align-center">
      <title-page title="Blast Email" />
      <v-btn
        class="text-capitalize"
        to="blast-email/history"
        color="var(--g)"
        depressed
        outlined
      >
        <v-icon class="mr-2">mdi-clipboard-text-clock-outline</v-icon>
        <b>History</b></v-btn
      >
    </div>

    <div class="py-3">
      <b>Select Recipient</b>
    </div>
    <div class="mb-3">
      <v-row>
        <v-col cols="3">
          <v-btn
            block
            color="var(--g)"
            @click="selectUser('group')"
            dark
            depressed
            >Group</v-btn
          >
        </v-col>
        <v-col cols="3">
          <v-btn
            block
            color="var(--g)"
            @click="selectUser('scholar')"
            dark
            depressed
            >Scholars</v-btn
          >
        </v-col>
        <v-col cols="3">
          <v-btn
            block
            color="var(--g)"
            @click="selectUser('vendor')"
            dark
            depressed
            >Vendor</v-btn
          >
        </v-col>
        <v-col cols="3">
          <v-btn block color="var(--g)" @click="selectUser('tf')" dark depressed
            >Tanoto Foundation</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div
      class="mb-3"
      v-if="
        inventory.scholar.length ||
        inventory.tf.length ||
        inventory.vendor.length ||
        inventory.group.length
      "
    >
      <b>Recipient</b>
      <v-card class="pa-2" flat>
        <div class="d-flex flex-wrap">
          <v-chip
            v-for="(item, i) in inventory.scholar"
            :key="`scholar-${i}`"
            class="ma-1"
          >
            {{ item.email }}
          </v-chip>
          <v-chip
            v-for="(item, i) in inventory.tf"
            :key="`tf-${i}`"
            class="ma-1"
          >
            {{ item.email }}
          </v-chip>
          <v-chip
            v-for="(item, i) in inventory.vendor"
            :key="`vendor-${i}`"
            class="ma-1"
          >
            {{ item.email }}
          </v-chip>
          <v-chip
            v-for="(item, i) in inventory.group"
            :key="`group-${i}`"
            class="ma-1"
          >
            {{ item.email }}
          </v-chip>
        </div>
      </v-card>
    </div>
    <b>Subject</b>
    <v-text-field
      solo
      v-model="subject"
      flat
      hide-details
      placeholder="Subject"
      class="mb-3"
    ></v-text-field>
    <b>Content</b>
    <vue-editor
      use-custom-image-handler
      @image-added="handleImageAdded"
      class="mb-3 white"
      placeholder="Type here..."
      v-model="message"
      :editorToolbar="customToolbar"
      id="editorblast"
    ></vue-editor>
    <b>Attachment</b>
    <v-file-input
      class="rounded-lg"
      color="green"
      v-model="attachment"
      placeholder="Select file"
      accept="image/jpeg, application/pdf"
      outlined
      dense
    ></v-file-input>
    <v-btn block depressed dark color="var(--g)" @click="startBlast"
      ><b>Send</b></v-btn
    >
    <div class="d-flex justify-end my-3"></div>
    <div class="pa-3">
      <dialog-blast
        ref="dialok"
        :d_blast="d_blast"
        @refetch="fetchData"
        @close="d_blast = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
        :width="d_width"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import titlePage from "../../components/atom/titlePage.vue";
import DialogBlast from "./dialogBlast.vue";
export default {
  components: { titlePage, DialogBlast },
  computed: {
    ...mapState({
      recipient: (state) => state.blast.recipient,
    }),
  },
  data() {
    return {
      inventory: {
        scholar: [],
        tf: [],
        vendor: [],
        group: [],
      },
      d_type: "",
      d_title: "",
      d_blast: false,
      d_width: "450px",
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }],
        ["image"],
      ],
      subject: "",
      message: "",
      attachment: null,
    };
  },
  methods: {
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      // const url = 'https://awsimages.detik.net.id/community/media/visual/2022/10/28/presiden-rusia-vladimir-putin-saat-berbicara-dalam-forum-klub-diskusi-internasional-valdai_169.jpeg?w=700&q=90';
      // Editor.insertEmbed(cursorLocation, "image", url);
      // resetUploader();
      var formData = new FormData();
      formData.append("image", file);
      this.$store
        .dispatch("blast/getUrlImageApi", formData)
        .then((result) => {
          const url = result.data; // Get url from response
         
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
              msg: e.message,
              type: "error",
            });
        });
    },
    fetchData() {
      console.log(".");
    },
    selectUser(type) {
      this.d_title = "Select User";
      this.d_width = "450px";
      this.d_type = type;
      this.d_blast = true;
      this.$refs.dialok.triggerChild();
    },
    startBlast() {
      let scholar = this.inventory.scholar.map((el) => {
        return el.email;
      });
      let tf = this.inventory.tf.map((el) => {
        return el.email;
      });
      let vendor = this.inventory.vendor.map((el) => {
        return el.email;
      });
      let group = this.inventory.group.map((el) => {
        return el.email;
      });
      let to = [...scholar, ...tf, ...vendor, ...group];
      let data = {
        body: {
          to: to,
          subject: this.subject,
          content: this.message,
        },
      };
      if(this.attachment != null){
        let data = {
          body: {
            to: to,
            subject: this.subject,
            content: this.message,
            attachment: this.attachment,
          },
        };
      }
      this.$store
        .dispatch("blast/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$router.push("blast-email/history");
        })
        .catch((e) => {
          if (e.data) {
            var key = Object.keys(e.data.errors);
            var values = Object.values(e.data.errors);
            for (let i = 0; i < key.length; i++) {
              for (let j = 0; j < values[i].length; j++) {
                this.$toast.error(values[i][j]);
              }
            }
          } else {
            this.$store.dispatch("notify", {
              msg: e.message,
              type: "error",
            });
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style >
.quillWrapper {
  border-radius: 8px;
}
</style>